// extracted by mini-css-extract-plugin
export default {"signUpPageDiv":"SignUp_signUpPageDiv__ZmeH7","signUpForm":"SignUp_signUpForm__ZpKSv","error":"SignUp_error__KrtfP","errorText":"SignUp_errorText__E05Ul"};